import { FeatureToggleClientService } from 'feature-toggle-client';
const USE_WEBSOCKET_COMMANDS_ON_HTTP_TRANSPORT = 'use-websocket-commands-on-http-transport';
const ENABLE_GET_DELEGATION_COMMANDS_LOGGING = 'enable-get-delegation-commands-logging';
const MESSAGING_HUB_COMMAND_WITH_DELEGATION = 'messaging-hub-command-with-delegation';
export class MessagingHubFeatures {
    static async useWebsocketCommands() {
        return await FeatureToggleClientService.getInstance()
            .isFeatureEnabled(USE_WEBSOCKET_COMMANDS_ON_HTTP_TRANSPORT);
    }
    static async enableGetDelegationCommandsLogging() {
        return await FeatureToggleClientService.getInstance()
            .isFeatureEnabled(ENABLE_GET_DELEGATION_COMMANDS_LOGGING);
    }
    static async GetMessagingHubCommandWithDelegation() {
        return await FeatureToggleClientService.getInstance()
            .isFeatureEnabled(MESSAGING_HUB_COMMAND_WITH_DELEGATION);
    }
    static async GetUserMessagingHubCommandWithDelegation() {
        return await FeatureToggleClientService.getInstance()
            .isUserFeatureEnabled(MESSAGING_HUB_COMMAND_WITH_DELEGATION);
    }
}
